<template>
      <CRow class="no-gutters">
        <CCol sm="8">
         <CCarousel
            class="image-carousel"
            indicators
            animate
            :interval="7000"
            height="100%"
          >
            <CCarouselItem>
              <img class="carousel-items img-banner" :src="Banner1"/>
            </CCarouselItem>
            <CCarouselItem>
              <img class="carousel-items img-banner" :src="Banner2"/>
            </CCarouselItem>
            <CCarouselItem>
              <img class="carousel-items img-banner" :src="Banner3"/>
            </CCarouselItem>
            <CCarouselItem>
              <img class="carousel-items img-banner" :src="Banner4"/>
            </CCarouselItem>
         </CCarousel>
        </CCol>
        <CCol sm="4" class="pl-5 pr-5">
          <CAlert
            style="position:absolute;width:80%"
            color="danger"
            :show.sync="currentAlertCounter"
            closeButton
          >
            {{errorMessage}}
          </CAlert>
          <div class="input-area mt-5">
            <div class="row no-gutters">
              <div class="col-md-12 text-center">
                <img :src="logos" width="180" height="80"/>
              </div>
            </div>
            <div class="row no-gutters mt-5">
              <div class="col-md-12">
                <h1 style="float:left">Log In</h1>
              </div>
            </div>
            <div class="row no-gutters pt-2">
              <div class="col-md-12">
                <label :class="labelEmailErr">Email</label>
                <input v-model="email" :class="classEmailErr" class="form-control rounded w-100" type="text"/>
                <label style="position:absolute" v-if="errEmailShow == 'errEmailShow'" :class="errEmailShow">Pastikan email valid</label>
                <label style="position:absolute" v-if="errEmailShow == 'not-error'" class="text-success" :class="errEmailShow">Email valid <font-awesome-icon :icon="{prefix: 'fas', iconName: 'check'}" /></label>
              </div>
            </div>
            <div class="row no-gutters pt-4">
              <div class="col-md-12">
                <label :class="labelPassErr">Password</label>
                <div class="input-group">
                  <input :type="typePassword" v-model="password" :class="classPassErr" class="form-control">
                  <div :class="classPassErr" class="input-group-append rounded-right">
                    <span style="cursor:pointer" @click="statusPassword()" v-if="typePassword == 'password'" class="input-group-text"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'eye'}" /></span>
                    <span style="cursor:pointer" @click="statusPassword()" v-else class="input-group-text"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'eye-slash'}" /></span>
                  </div>
                </div>
                <label style="position:absolute" v-if="errPassShow == 'errPassShow'" :class="errPassShow">Pastikan password lebih dari 8 karakter</label>
                <label style="position:absolute" v-if="errPassShow == 'not-error'" class="text-success" :class="errPassShow">Password valid <font-awesome-icon :icon="{prefix: 'fas', iconName: 'check'}" /></label>
              </div>
            </div>
            <div class="row no-gutters mt-5">
              <div class="col-md-12">
                <CButton @click="goLogin()" class="w-100 btn-primary">
                  <span v-if="loading == false">Log In</span>
                  <CSpinner v-else color="default" size="sm"/>
                </CButton>
              </div>
            </div>
            <div class="row no-gutters mt-3">
              <div class="col-md-12">
                <CButton @click="loginGoogle" class="w-100 btn-light">
                  <svg v-if="loadingGoogle == false" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><title>Google</title><g fill="none" fill-rule="evenodd"><path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2581h2.9087c1.7018-1.5668 2.6836-3.874 2.6836-6.615z"></path><path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.4818 18 9 18z"></path><path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573A8.9965 8.9965 0 0 0 0 9c0 1.4523.3477 2.8268.9573 4.0418L3.964 10.71z"></path><path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.6559 3.5795 9 3.5795z"></path></g></svg>
                  <span v-if="loadingGoogle == false"> Sign In via Google</span>
                  <CSpinner v-if="loadingGoogle == true" color="default" size="sm"/>
                </CButton>
              </div>
            </div>
            <div class="row no-gutters mt-5">
              <div class="col-md-12">
                <h6 class="text-center">Don't have account? <span class="text-primary">Sign up</span></h6>
              </div>
            </div>
            <div class="row no-gutters mt-1">
              <div class="col-md-12">
                <h6 class="text-center"><span class="text-primary">Forgot password?</span></h6>
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
</template>

<script>
import {AuthLogin} from "../../service/Auth"
import {DataApi} from '@/service/DataApi'
export default {
  name: 'Login',
  data() {
    return {
      logos: require('../../assets/image/logos.svg'),
      Banner1: require('../../assets/image/Banner_1.svg'),
      Banner2: require('../../assets/image/Banner_2.svg'),
      Banner3: require('../../assets/image/Banner_3.svg'),
      Banner4: require('../../assets/image/Banner_4.svg'),
      loading: '',
      loadingGoogle: '',
      email: '',
      password: '',
      typePassword: 'password',
      classEmailErr: '',
      labelEmailErr: '',
      errEmailShow: '',
      classPassErr: '',
      labelPassErr: '',
      errPassShow: '',
      emailvalid: false,
      passwordvalid: false,
      errorMessage: '',
      roles: '',
      rolesMenu: [],
      menus: [],
      finded: [],
      parentId: [],
      parentMenus: [],
      currentAlertCounter: 0
    }
  },
  watch: {
    email() {
      this.validateEmail();
    },
    password() {
      this.validatePass()
    }
  },
  beforeCreate() {
    if (localStorage.getItem("token")) {
      this.$router.replace("/dashboard")
    }
  },
  methods: {
    async loginGoogle(){
      const googleUser = await this.$gAuth.signIn()
      let profile = googleUser.getBasicProfile()
      this.loadingGoogle = true
      this.loading = false
      if(profile.getEmail() == undefined) {
        this.errorMessage = 'CANNOT GET DATA FROM GOOGLE. PLEASE TRY AGAIN.'
        this.currentAlertCounter = 5
        this.loadingGoogle = false
      } else {
        let usernames = profile.getEmail()
        let payload = {
          appVersion: "1",
          deviceId: "web",
          deviceType: "web",
          deviceVersion: "1.0",
          email: profile.getEmail(),
          name: profile.getName(),
          username: usernames.split("@gmail")[0],
          usernameBy: "2"
        }
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        AuthLogin.post('user/checkpass', payload, config)
        .then(res => {
          let response = res.data.data.Data2
          if(res.data.success == true) {
            this.loadingGoogle = false
            localStorage.setItem("token", response.token)
            localStorage.setItem("urlFoto", profile.getImageUrl())
            localStorage.setItem("login", 'google')
            this.updateNotif()
            let dataMenu = response.role.menus
              let menu = []
              var i
              for(i=0;i<dataMenu.length;i++) {
                if(dataMenu[i].childs != undefined) {
                  var j = 0
                  for(j=0;j<dataMenu[i].childs.length;j++) {
                    let hasChild = dataMenu[i].childs
                    if(hasChild[j].childs != undefined) {
                      var k = 0
                      for(k=0;k<hasChild[j].childs.length;k++) {
                        let hasGrandChild = hasChild[j].childs
                        menu.push(hasGrandChild[k].name)
                      }
                    } else {
                      menu.push(hasChild[j].name)
                    }
                  }
                } else {
                  menu.push(dataMenu[i].name)
                }
              }
              localStorage.setItem("menus", menu)
              this.getSidebar(dataMenu)
            this.$router.replace("/dashboard");
            //
          } else {
            this.loadingGoogle = false
            this.errorMessage = res.data.message
            this.currentAlertCounter = 5
          }
          this.$store.state.messageAuth = false
        })
      }
    },
    goLogin() {
      if(this.emailvalid == false) {
        if(this.passwordvalid == false) {
          this.errorMessage = "Email and Password Not Valid !"
          this.currentAlertCounter = 5
        } else {
          this.errorMessage = "Email Not Valid !"
          this.currentAlertCounter = 5
        }
      } else {
        if(this.passwordvalid == false) {
          this.errorMessage = "Password Not Valid !"
          this.currentAlertCounter = 5
        } else {
          this.onLogin()
        }
      }
    },
    onLogin() {
      this.loading = true
      this.loadingGoogle = false
      let data = {
          'email': this.email,
          'password': this.password,
          'type': 1
      };
      const config = {
          headers: {
              'Content-Type': 'application/json'
          }
      };
      /**
       * Set TOKEN to LocalStorage
       */
      AuthLogin.post('user/login', data, config)
          .then(response => {
              let res = response.data;
              if(res.success == true) {
                this.loading = false
                localStorage.setItem("token", res.data.token)
                localStorage.setItem("urlFoto", res.data.urlFoto)
                localStorage.setItem("login", 'non-google')
                this.updateNotif()
                let dataMenu = res.data.role.menus
                let menu = []
                var i
                for(i=0;i<dataMenu.length;i++) {
                  if(dataMenu[i].childs != undefined) {
                    var j = 0
                    for(j=0;j<dataMenu[i].childs.length;j++) {
                      let hasChild = dataMenu[i].childs
                      if(hasChild[j].childs != undefined) {
                        var k = 0
                        for(k=0;k<hasChild[j].childs.length;k++) {
                          let hasGrandChild = hasChild[j].childs
                          menu.push(hasGrandChild[k].name)
                        }
                      } else {
                        menu.push(hasChild[j].name)
                      }
                    }
                  } else {
                    menu.push(dataMenu[i].name)
                  }
                }
                localStorage.setItem("menus", menu)
                this.getSidebar(dataMenu)
                let base = localStorage.getItem("prevUrl")
                if(base === '/') {
                  this.$router.replace("/dashboard")
                } else {
                  this.$router.replace(base);
                }
                
              } else {
                this.errorMessage = res.message
                this.currentAlertCounter = 5
                this.loading = false
              }
              this.$store.state.messageAuth = false
          })
    },
    statusPassword() {
      if(this.typePassword == 'password') {
        this.typePassword = 'text'
      } else {
        this.typePassword = 'password'
      }
    },
    validateEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const Regex = re.test(String(this.email).toLowerCase())
      if(Regex == false) {
        this.classEmailErr = 'classEmailErr'
        this.labelEmailErr = 'labelEmailErr'
        this.errEmailShow = 'errEmailShow'
        this.emailvalid = false
      } else {
        this.classEmailErr = 'classEmailSuccess'
        this.labelEmailErr = ''
        this.errEmailShow = 'not-error'
        this.emailvalid = true
      }
    },
    validatePass() {
      if(this.password.length < 8) { 
        this.classPassErr = 'classPassErr'
        this.labelPassErr = 'labelPassErr'
        this.errPassShow = 'errPassShow'
        this.passwordvalid = false
      } else {
        this.classPassErr = 'classPassSuccess'
        this.labelPassErr = ''
        this.errPassShow = 'not-error'
        this.passwordvalid = true
      }
    },
    getSidebar(menu) {
      var i = 0
      for(i=0;i<menu.length;i++) {
        if(menu[i].childs == null || menu[i].childs == 0 || menu[i].childs == 'null' || menu[i].childs == '' || menu[i].childs == undefined) {
          let onPush = {
            name : menu[i].name,
            activeClass : 'not-active',
            to : menu[i].path,
            items: ''
          }
          this.menus.push(onPush)
        }
        else {
          var j = 0
          let itemPush = []
          let hasChild = menu[i].childs
          for(j=0;j<hasChild.length;j++) {
            if(hasChild[j].childs == null || hasChild[j].childs == 0 || hasChild[j].childs == 'null' || hasChild[j].childs == '' || hasChild[j].childs == undefined) {
              let item = {
                name : hasChild[j].name,
                activeClass : 'not-active',
                to : hasChild[j].path,
                items: ''
              }
              itemPush.push(item)
            } else {
              var k = 0
              let childPush = []
              let hasGrandChild = hasChild[j].childs
              for(k=0;k<hasGrandChild.length;k++) {
                let li = {
                  name : hasGrandChild[k].name,
                  activeClass : 'not-active',
                  to : hasGrandChild[k].path,
                  items: ''
                }
                childPush.push(li)
              }
              let items = {
                id: hasChild[j].id,
                name : hasChild[j].name,
                rotate: 'rotateOff',
                status: false,
                items: childPush
              }
              itemPush.push(items)
            }
          }
          let pushParentId = {
            id : menu[i].id,
            name : menu[i].name,
            rotate: 'rotateOff',
            status: false,
            items : itemPush
          }
          this.parentId.push(pushParentId)
      }
    }
    var h = 0
      for(h=0;h<this.parentId.length;h++) {
        this.menus.push(this.parentId[h])
      }
      localStorage.setItem("draftMenu", JSON.stringify(this.menus))
    },
    /**
     * notif
     */
     updateNotif() {
          DataApi.post('surat/notification')
          .then( res => {
              localStorage.setItem('notif', JSON.stringify(res.data.data))
          })
      },
  },
  mounted() {
    if(this.$store.state.messageAuth == true) {
      this.errorMessage = "Maaf, Session Anda Telah Habis. Silahkan Login Kembali."
      this.currentAlertCounter = 5
    }
  },
}
</script>

<style lang="scss">
.classEmailErr, .classPassErr {
  border: 1px solid red !important;
  box-shadow: none !important;
}
.labelEmailErr, .labelPassErr, .errEmailShow, .errPassShow {
  color: red;
}

.classEmailSuccess, .classPassSuccess {
  border: 1px solid #2eb85c !important;
  box-shadow: none !important;
}

@media (min-width: 400px) {
  .image-carousel {
    display: none;
  }
  // .carousel-items {
  //   width: 100%;
  //   height: 40vh;
  //   opacity: 0.8;
  // }
  // .input-area {
  //   padding: 64px;
  // }
}
@media (min-width: 576px) {
  .image-carousel {
    display: contents;
  }
  .carousel-items {
    width: 100%;
    height: 100vh;
  }
}
@media (min-width: 1200px) {
.carousel-items {
    width: 100%;
    height: 100vh;
  }
}
.img-banner {
  width: 100%;
  object-fit: cover;
}
</style>